import { render } from "./add-patient.vue?vue&type=template&id=3f648345"
import script from "./add-patient.vue?vue&type=script&lang=js"
export * from "./add-patient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__